import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { useIsTablet } from '@hooks/responsive/useIsMobile';

// components
import Tabbar from '@components/_atoms/Tabbar';

// constants
import { TABLET_MODE } from '@constants/size';
import { searchPath } from '@constants/routes/routes';
import { TabbarAlign } from '@constants/atoms';

// type
import { TabType } from '../types';
import { useTranslation } from 'next-i18next';
import userGetEtcText from '@hooks/service/useGetEtcText';
import { useGetProductType } from '@hooks/fetch/useProductFetch';
import { useGetProductTypeLabel } from '@hooks/service/useGetProductLabel';
import { MultiStandardProductTypeList } from '../../SearchDetailContent/types';

type Props = {
  product_type_id: number;
};

const Layout = styled.div<{ productType?: string }>`
  margin-bottom: ${({ productType }) => MultiStandardProductTypeList.includes(productType!) ? '10px' : '40px'};

  @media ${TABLET_MODE} {
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    overflow-x: auto;
  }
`;

export default function TabbarBox({ product_type_id }: Props) {
  const router = useRouter();
  const isTablet = useIsTablet();
  const etcText: string = userGetEtcText();

  const { getProductTypeFetchData } = useGetProductType();
  const productTypeLabel = getProductTypeFetchData?.map((item) => item?.exposed_product_type || '');
  const productTypeInfo = getProductTypeFetchData?.find((item) => item.id === product_type_id);
  const selectLabel = productTypeInfo?.exposed_product_type;

  // tabbar click
  const handleClickTabbar = (e: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = e.target as HTMLButtonElement;
    const productTypeInfo = getProductTypeFetchData?.find((item) => item.exposed_product_type === value);

    const BUYER_SEARCH = searchPath.query({ product_type: productTypeInfo?.id! });
    router.push(BUYER_SEARCH);
  };

  useEffect(() => {
  }, [getProductTypeFetchData]);

  return (
    <Layout productType={selectLabel}>
      <Tabbar
        selectLabel={selectLabel}
        label={productTypeLabel}
        onClick={handleClickTabbar}
        align={isTablet ? TabbarAlign.CENTER : TabbarAlign.LEFT}
      />
    </Layout>
  );
}
